import React from 'react';
import { CheckCircleIcon, TrendingUpIcon, AlertTriangleIcon } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { GlassCard } from '../ui/GlassCard';
export function CompetenceAuthority() {
  return <SectionWrapper hasDivider glowPosition="right" data-id="element-2">
      <div className="max-w-3xl mb-16" data-id="element-3">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-6" data-id="element-4">
          Civic influence tied to demonstrated competence
        </h2>
        <p className="text-lg text-slate-400 leading-relaxed" data-id="element-5">
          Under this system, civic influence and access to leadership are tied
          to demonstrated competence rather than popularity, impulse, or
          inherited status. Those who exhibit stronger reasoning, greater
          stability, and higher civic reliability are entrusted with greater
          responsibility.
        </p>
      </div>

      <div className="flex flex-col gap-6" data-id="element-6">
        {/* Tier 1 */}
        <GlassCard glowColor="green" className="relative overflow-hidden border-l-4 border-l-green-500" data-id="element-7">
          <div className="absolute top-0 right-0 p-6 opacity-10 pointer-events-none" data-id="element-8">
            <CheckCircleIcon className="w-32 h-32 text-green-500" data-id="element-9" />
          </div>
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 relative z-10" data-id="element-10">
            <div className="flex items-start gap-4" data-id="element-11">
              <div className="w-12 h-12 rounded-full bg-green-500/10 flex items-center justify-center shrink-0 border border-green-500/20" data-id="element-12">
                <CheckCircleIcon className="w-6 h-6 text-green-400" data-id="element-13" />
              </div>
              <div data-id="element-14">
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-15">
                  High Competence
                </h3>
                <p className="text-slate-400" data-id="element-16">
                  Entrusted with greater civic, legal, and strategic
                  responsibility
                </p>
              </div>
            </div>
            <div className="shrink-0" data-id="element-17">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-green-500/10 border border-green-500/20" data-id="element-18">
                <span className="text-sm font-mono text-green-400" data-id="element-19">
                  NCJI 85+
                </span>
              </div>
            </div>
          </div>
        </GlassCard>

        {/* Tier 2 */}
        <GlassCard glowColor="cyan" className="relative overflow-hidden border-l-4 border-l-cyan-500" data-id="element-20">
          <div className="absolute top-0 right-0 p-6 opacity-10 pointer-events-none" data-id="element-21">
            <TrendingUpIcon className="w-32 h-32 text-cyan-500" data-id="element-22" />
          </div>
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 relative z-10" data-id="element-23">
            <div className="flex items-start gap-4" data-id="element-24">
              <div className="w-12 h-12 rounded-full bg-cyan-500/10 flex items-center justify-center shrink-0 border border-cyan-500/20" data-id="element-25">
                <TrendingUpIcon className="w-6 h-6 text-cyan-400" data-id="element-26" />
              </div>
              <div data-id="element-27">
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-28">
                  Developing Capacity
                </h3>
                <p className="text-slate-400" data-id="element-29">
                  Standard civic participation with structured development
                  support
                </p>
              </div>
            </div>
            <div className="shrink-0" data-id="element-30">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-cyan-500/10 border border-cyan-500/20" data-id="element-31">
                <span className="text-sm font-mono text-cyan-400" data-id="element-32">
                  NCJI 50-84
                </span>
              </div>
            </div>
          </div>
        </GlassCard>

        {/* Tier 3 */}
        <GlassCard glowColor="amber" className="relative overflow-hidden border-l-4 border-l-amber-500" data-id="element-33">
          <div className="absolute top-0 right-0 p-6 opacity-10 pointer-events-none" data-id="element-34">
            <AlertTriangleIcon className="w-32 h-32 text-amber-500" data-id="element-35" />
          </div>
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 relative z-10" data-id="element-36">
            <div className="flex items-start gap-4" data-id="element-37">
              <div className="w-12 h-12 rounded-full bg-amber-500/10 flex items-center justify-center shrink-0 border border-amber-500/20" data-id="element-38">
                <AlertTriangleIcon className="w-6 h-6 text-amber-400" data-id="element-39" />
              </div>
              <div data-id="element-40">
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-41">
                  Vulnerability to Capture
                </h3>
                <p className="text-slate-400" data-id="element-42">
                  Directed toward improvement tracks until measurable progress
                  is shown
                </p>
              </div>
            </div>
            <div className="shrink-0" data-id="element-43">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-amber-500/10 border border-amber-500/20" data-id="element-44">
                <span className="text-sm font-mono text-amber-400" data-id="element-45">
                  NCJI &lt;50
                </span>
              </div>
            </div>
          </div>
        </GlassCard>
      </div>
    </SectionWrapper>;
}